module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Q7nD7z/tc-custom/9781452156712.jpg?1737761272376",
      "alt": "This image is the cover for the book Rachel Khoo's Kitchen Notebook"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rachel Khoo's Kitchen Notebook\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An inspiring, intimate cookbook with kitchen notes and photos from the BBC and Food Network chef.")]), _c('br'), _c('br'), _vm._v("Rachel Khoo—bestselling author, BBC and Food Network personality, and international tastemaker—offers a constellation of ideas and creative inspiration in this exuberant more-than-a-cookbook. Each page offers doable and delicious recipes, style-setting ideas from around the globe, and Rachel’s charming illustrations and engaging notes. "), _c('br'), _c('br'), _vm._v("With 250 photographs, it’s a delightful companion for cooks that will brings surprises and smiles as well as scrumptious food. Learn to make:"), _c('br'), _c('br'), _vm._v("Roasted Cauliflower and Caraway Salad * Speedy Chorizo and Chickpea Stew * Teriyaki Salmon Steamed Buns * Bread-Wrapped Lamb Kebabs * Potato Crumpets with Maple Mustard Glaze * Dark Chocolate and Cherry Cookies * Lemon Lava Cakes * and many more\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rachel Khoo\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Rachel Khoo is the host of the popular television series The Little Paris Kitchen and a columnist for the London Evening Standard. She divides her time between Paris and London.David Loftus is a London-based food and lifestyle photographer.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0